import * as React from 'react'
import { designTokens } from '../../lib/design-tokens'

type IconProps = React.SVGProps<SVGSVGElement> & {
  color?: string
  strokeWidth?: string | number
}

export const SearchIcon = ({
  width = designTokens.components.account.search.iconSize,
  height = designTokens.components.account.search.iconSize,
  color = designTokens.colors.text.adminPlaceholder,
  strokeWidth = designTokens.components.account.search.iconStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 5.11064 5.22668"
    fill="none"
    focusable="false"
    aria-hidden="true"
    {...props}
  >
    <circle
      cx="2.24069"
      cy="2.24069"
      r="2.0152"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.62564 3.74167L4.88514 5.00118"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

SearchIcon.displayName = 'SearchIcon'
